import { createApp } from 'vue';
import SvgVue from 'svg-vue3';
import Axios from 'axios';
import Toaster from "@meforma/vue-toaster";
import { VueReCaptcha } from 'vue-recaptcha-v3'
import App from './vue/App'
import store from './vue/store'
import router from './vue/router'
import '../js/gallery';
import '../js/header';
import VueCookies from 'vue-cookies'

//config
Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Axios.defaults.withCredentials = true;

const VueApp = createApp(App);

// Add global properties
VueApp.use(VueReCaptcha, { siteKey: process.env.MIX_RECAPTCHAV3_SITEKEY, loaderOptions: {autoHideBadge: true} });
VueApp.use(SvgVue);
VueApp.use(Toaster, {
    position: "top-right",
    duration: 3000,
}).provide('toast', VueApp.config.globalProperties.$toast);
VueApp.use(VueCookies, { expire: '7d'})
VueApp.use(store);
VueApp.use(router);

window.addEventListener('load', function () {
    document.querySelectorAll('#app').forEach( (element) => VueApp.mount(element) );
});
